import React from 'react'
import './TitleSectionComponent.css'
import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router'
export default function TitleSectionComponent({ title, icon, url, isShowMore = false }) {
  const nav = useNavigate();
  return (
    <div className='title-section d-flex justify-between'>
      <div className='d-flex items-center gap-3'>
        <div className='title-icon'>
          {icon}
        </div>
        <h1>{title}</h1>
      </div>
      {
        isShowMore ? (
          <div>
            <Button title='مشاهده همه' onClick={() => nav(url)}>
              مشاهده همه
            </Button>
          </div>
        ) : null
      }

    </div>
  )
}
